import type { Service } from "@/lib/types";
import { useTranslations } from "@/i18n/LocaleProvider";
import { SHOW_PRICING } from "@/lib/featureFlags";
import Spinner from "@/components/Spinner";

export default function ServiceStep({
  services,
  loading,
  onSelect,
}: {
  services: Service[];
  loading: boolean;
  onSelect: (service: Service) => void;
}) {
  const { t } = useTranslations();
  return (
    <div className="mt-3 space-y-2 sm:mt-4 sm:space-y-2.5">
      {loading ? (
        <div className="flex justify-center py-6 text-muted sm:py-8">
          <Spinner className="size-6" />
        </div>
      ) : (
        services.length === 0 && (
          <p className="text-sm text-muted">{t("book.service.empty")}</p>
        )
      )}
      {services.map((service) => (
        <button
          key={service.id}
          onClick={() => onSelect(service)}
          className="flex w-full items-center justify-between rounded-xl border border-foreground/10 bg-surface px-4 py-2.5 text-left transition hover:border-accent sm:py-3"
        >
          <span>
            <span className="font-semibold">{service.name}</span>
            <span className="ml-2 text-sm text-muted">
              {t("book.service.duration", { minutes: service.durationMinutes })}
            </span>
          </span>
          {SHOW_PRICING && <span className="font-semibold text-accent">₹{service.priceInr}</span>}
        </button>
      ))}
    </div>
  );
}
